const remo = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 25/26 - Uniforme Edição Especial",
    aliases: ["remo", "leão", "retro", "remo", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/remo/25-26-00-es/remo0.png",
      "/images/brasil/serie-a/remo/25-26-00-es/remo1.png",
      "/images/brasil/serie-a/remo/25-26-00-es/remo2.png",
      "/images/brasil/serie-a/remo/25-26-00-es/remo3.png",
      "/images/brasil/serie-a/remo/25-26-00-es/remo4.png",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 99/00 - Uniforme 1 Retro",
    aliases: ["remo", "leão", "retro", "retro remo", "remo retro"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/remo/99-00-01/remo0.png",
      "/images/brasil/serie-a/remo/99-00-01/remo1.png",
      "/images/brasil/serie-a/remo/99-00-01/remo2.png",
      "/images/brasil/serie-a/remo/99-00-01/remo3.png",
      "/images/brasil/serie-a/remo/99-00-01/remo4.png",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 25/26 - Uniforme 1",
    aliases: ["remo", "leão", "retro", "remo 2025", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/25-26-01/remo0.jpg",
      "/images/brasil/serie-a/remo/25-26-01/remo1.jpg",
      "/images/brasil/serie-a/remo/25-26-01/remo2.jpg",
      "/images/brasil/serie-a/remo/25-26-01/remo3.jpg",
      "/images/brasil/serie-a/remo/25-26-01/remo4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 25/26 - Uniforme 1 (Feminina)",
    aliases: [
      "remo",
      "leão",
      "retro",
      "remo 2025",
      "2025",
      "feminino",
      "remo feminino",
      "feminio remo",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/25-26-01-f/remo0.jpg",
      "/images/brasil/serie-a/remo/25-26-01-f/remo1.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 25/26 - Uniforme de Goleiro (Roxa)",
    aliases: ["remo", "leão", "retro", "remo 2025", "2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/25-26-05-gr/remo0.jpg",
      "/images/brasil/serie-a/remo/25-26-05-gr/remo1.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 25/26 - Uniforme de Goleiro (Roxa) (Feminina)",
    aliases: [
      "remo",
      "leão",
      "retro",
      "remo 2025",
      "2025",
      "feminino",
      "remo feminino",
      "feminio remo",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/25-26-05-grf/remo0.jpg",
      "/images/brasil/serie-a/remo/25-26-05-grf/remo1.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 24/25 - Uniforme Edição Especial",
    aliases: ["remo", "leão", "retro", "remo 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/24-25-00-es/remo0.jpg",
      "/images/brasil/serie-a/remo/24-25-00-es/remo1.jpg",
      "/images/brasil/serie-a/remo/24-25-00-es/remo2.jpg",
      "/images/brasil/serie-a/remo/24-25-00-es/remo3.jpg",
      "/images/brasil/serie-a/remo/24-25-00-es/remo4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 24/25 - Uniforme 1",
    aliases: ["remo", "leão", "retro", "remo 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/24-25-01/remo0.jpg",
      "/images/brasil/serie-a/remo/24-25-01/remo1.jpg",
      "/images/brasil/serie-a/remo/24-25-01/remo2.jpg",
      "/images/brasil/serie-a/remo/24-25-01/remo3.jpg",
      "/images/brasil/serie-a/remo/24-25-01/remo4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 24/25 - Uniforme 2",
    aliases: ["remo", "leão", "retro", "remo 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/24-25-02/remo0.jpg",
      "/images/brasil/serie-a/remo/24-25-02/remo1.jpg",
      "/images/brasil/serie-a/remo/24-25-02/remo2.jpg",
      "/images/brasil/serie-a/remo/24-25-02/remo3.jpg",
      "/images/brasil/serie-a/remo/24-25-02/remo4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 24/25 - Uniforme de Goleiro (Cinza)",
    aliases: ["remo", "leão", "retro", "remo 2024", "2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/24-25-05-gc/remo0.jpg",
      "/images/brasil/serie-a/remo/24-25-05-gc/remo1.jpg",
      "/images/brasil/serie-a/remo/24-25-05-gc/remo2.jpg",
      "/images/brasil/serie-a/remo/24-25-05-gc/remo3.jpg",
      "/images/brasil/serie-a/remo/24-25-05-gc/remo4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 23/24 - Uniforme 1",
    aliases: ["remo", "leão", "retro", "remo 2023", "2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/23-24-01/remo0.jpg",
      "/images/brasil/serie-a/remo/23-24-01/remo1.jpg",
      "/images/brasil/serie-a/remo/23-24-01/remo2.jpg",
      "/images/brasil/serie-a/remo/23-24-01/remo3.jpg",
      "/images/brasil/serie-a/remo/23-24-01/remo4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "remo",
    nome: "Remo 22/23 - Uniforme 1",
    aliases: ["remo", "leão", "retro", "remo 2022", "2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/remo/22-23-01/remo0.jpg",
      "/images/brasil/serie-a/remo/22-23-01/remo1.jpg",
    ],
  },
];

export default remo;
